// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#AdminUserChatReport {
  /* Chat Log Styles */
  /* Modal Styles */
}
#AdminUserChatReport .margin-bottom-16px {
  margin-bottom: 16px;
}
#AdminUserChatReport .markdown-preview-card .markdown-content {
  padding: 16px;
  background: #fff;
  border-radius: 6px;
  line-height: 1.7;
}
#AdminUserChatReport .markdown-preview-card .markdown-content .text-size-h1 {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 8px;
}
#AdminUserChatReport .markdown-preview-card .markdown-content .text-size-h2 {
  display: block;
  font-size: 1.2rem;
  font-weight: 600;
  margin-top: 12px;
  margin-bottom: 8px;
}
#AdminUserChatReport .markdown-preview-card .markdown-content .bold {
  font-weight: 700;
}
#AdminUserChatReport .markdown-preview-card .markdown-content a {
  color: #1a73e8;
  text-decoration: underline;
}
#AdminUserChatReport .markdown-preview-card .markdown-content ul,
#AdminUserChatReport .markdown-preview-card .markdown-content li {
  margin-left: 16px;
}
#AdminUserChatReport .chat-area {
  height: 800px;
  overflow-y: auto;
  padding: 16px;
}
#AdminUserChatReport .chat-area::-webkit-scrollbar {
  display: none;
}
#AdminUserChatReport .chat-user {
  text-align: left;
}
#AdminUserChatReport .chat-user:not(:first-child) {
  margin-top: 32px;
}
#AdminUserChatReport .chat-assistant {
  text-align: left;
  margin-top: 8px;
}
#AdminUserChatReport .chat-icon {
  margin: 0 5px;
}
#AdminUserChatReport .chat-text {
  padding-left: 5px;
  white-space: pre-wrap;
  word-break: break-word;
}
#AdminUserChatReport .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
#AdminUserChatReport .modal-overlay .background-gray {
  background-color: #f9f9f9;
}
#AdminUserChatReport .modal-content {
  background: #fff;
  width: 90%;
  max-width: 800px;
  height: 90%;
  max-height: 800px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
#AdminUserChatReport .modal-header {
  height: 64px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
}
#AdminUserChatReport .modal-header .text-size-h2 {
  font-weight: 600;
  font-size: 1.25rem;
}
#AdminUserChatReport .modal-header .close-button {
  width: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
#AdminUserChatReport .modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
  background-color: #f9f9f9;
}
#AdminUserChatReport .modal-body .markdown-content {
  background: #fff;
  padding: 24px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
#AdminUserChatReport .generating-modal {
  height: auto;
  max-height: 400px;
}
#AdminUserChatReport .report-generating {
  flex: 1 1;
  padding: 48px 24px;
}
#AdminUserChatReport .report-loading-badge {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background-color: var(--primary-color-main, #1F3A5F);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
#AdminUserChatReport .report-loading-badge .loading-box {
  --base-size: 40px;
}
#AdminUserChatReport .modal-footer {
  height: 64px;
  padding: 0 24px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
}
#AdminUserChatReport .scroll-button {
  position: fixed;
  bottom: 16px;
  right: 16px;
  width: 64px;
  height: 64px;
  z-index: var(--z-index-local-over-5);
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/AdminUserChatReport.scss"],"names":[],"mappings":"AAAA;EAyCI,oBAAA;EAiCA,iBAAA;AAvEJ;AAFI;EACI,mBAAA;AAIR;AADI;EACI,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAGR;AAAI;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAER;AACI;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AACR;AAEI;EACI,gBAAA;AAAR;AAGI;EACI,cAAA;EACA,0BAAA;AADR;AAII;;EAEI,iBAAA;AAFR;AAMI;EACI,aAAA;EACA,gBAAA;EACA,aAAA;AAJR;AAKQ;EACI,aAAA;AAHZ;AAOI;EACI,gBAAA;AALR;AAMQ;EACI,gBAAA;AAJZ;AAQI;EACI,gBAAA;EACA,eAAA;AANR;AASI;EACI,aAAA;AAPR;AAUI;EACI,iBAAA;EAEA,qBAAA;EACA,sBAAA;AATR;AAaI;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAXR;AAaQ;EACI,yBAAA;AAXZ;AAeI;EACI,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;AAbR;AAgBI;EACI,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;AAdR;AAgBQ;EACI,gBAAA;EACA,kBAAA;AAdZ;AAiBQ;EACI,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAfZ;AAmBI;EACI,SAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;AAjBR;AAmBQ;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;AAjBZ;AAsBI;EACI,YAAA;EACA,iBAAA;AApBR;AAuBI;EACI,SAAA;EACA,kBAAA;AArBR;AAyBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oDAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvBR;AAyBQ;EACI,iBAAA;AAvBZ;AA2BI;EACI,YAAA;EACA,eAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AAzBR;AA4BI;EACI,eAAA;EACA,YAAA;EACA,WAAA;EAEA,WAAA;EACA,YAAA;EAEA,oCAAA;AA5BR","sourcesContent":["#AdminUserChatReport{\n    .margin-bottom-16px {\n        margin-bottom: 16px;\n    }\n\n    .markdown-preview-card .markdown-content {\n        padding: 16px;\n        background: #fff;\n        border-radius: 6px;\n        line-height: 1.7;\n    }\n\n    .markdown-preview-card .markdown-content .text-size-h1 {\n        display: block;\n        font-size: 1.5rem;\n        font-weight: 700;\n        margin-bottom: 8px;\n    }\n\n    .markdown-preview-card .markdown-content .text-size-h2 {\n        display: block;\n        font-size: 1.2rem;\n        font-weight: 600;\n        margin-top: 12px;\n        margin-bottom: 8px;\n    }\n\n    .markdown-preview-card .markdown-content .bold {\n        font-weight: 700;\n    }\n\n    .markdown-preview-card .markdown-content a {\n        color: #1a73e8;\n        text-decoration: underline;\n    }\n\n    .markdown-preview-card .markdown-content ul,\n    .markdown-preview-card .markdown-content li {\n        margin-left: 16px;\n    }\n\n    /* Chat Log Styles */\n    .chat-area {\n        height: 800px;\n        overflow-y: auto;\n        padding: 16px;\n        &::-webkit-scrollbar {\n            display: none;\n        }\n    }\n\n    .chat-user{\n        text-align: left;\n        &:not(:first-child) {\n            margin-top: 32px;\n        }\n    }\n\n    .chat-assistant{\n        text-align: left;\n        margin-top: 8px;\n    }\n\n    .chat-icon{\n        margin: 0 5px;\n    }\n\n    .chat-text {\n        padding-left: 5px;\n        // max-width: 1000px;\n        white-space: pre-wrap;\n        word-break: break-word;\n    }\n\n    /* Modal Styles */\n    .modal-overlay {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100vw;\n        height: 100vh;\n        background-color: rgba(0, 0, 0, 0.5);\n        z-index: 9999;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        .background-gray {\n            background-color: #f9f9f9;\n        }\n    }\n\n    .modal-content {\n        background: #fff;\n        width: 90%;\n        max-width: 800px;\n        height: 90%;\n        max-height: 800px;\n        border-radius: 8px;\n        display: flex;\n        flex-direction: column;\n        box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n    }\n\n    .modal-header {\n        height: 64px;\n        padding: 0 24px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        border-bottom: 1px solid #e0e0e0;\n\n        .text-size-h2 {\n            font-weight: 600;\n            font-size: 1.25rem;\n        }\n        \n        .close-button {\n            width: 40px;\n            padding: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n    }\n\n    .modal-body {\n        flex: 1;\n        overflow-y: auto;\n        padding: 24px;\n        background-color: #f9f9f9;\n        \n        .markdown-content {\n            background: #fff;\n            padding: 24px;\n            border-radius: 4px;\n            box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n        }\n    }\n\n    // 生成中モーダル: タイトルとローディング表示のみのコンパクト構成\n    .generating-modal {\n        height: auto;\n        max-height: 400px;\n    }\n\n    .report-generating {\n        flex: 1;\n        padding: 48px 24px;\n    }\n\n    // primary色の円形バッジに LoadingBox を載せて視認性を確保\n    .report-loading-badge {\n        width: 88px;\n        height: 88px;\n        border-radius: 50%;\n        background-color: var(--primary-color-main, #1F3A5F);\n        color: #ffffff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        .loading-box {\n            --base-size: 40px;\n        }\n    }\n\n    .modal-footer {\n        height: 64px;\n        padding: 0 24px;\n        border-top: 1px solid #e0e0e0;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        gap: 16px;\n    }\n\n    .scroll-button{\n        position: fixed;\n        bottom: 16px;\n        right: 16px;\n\n        width: 64px;\n        height: 64px;\n\n        z-index: var(--z-index-local-over-5);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
